import { listGameCategory } from '@/api/gameManage/gameTag';

export const getOptions = () => {
  return listGameCategory({
    page: 1,
    page_size: 100,
  }).then(res => {
    return res.data?.list?.map(item => {
      return {
        value: item.title,
        label: item.title,
      }
    }) || [];
  })
};

export default {
  getOptions,
  async: true,
  placeholder: '请选择游戏标签'
}
